<template>
  <parent>
    <div>
      <paper-simple>
        <div class="row">
          <input-field
            label="Organization Name"
            label-position="top"
            class="px-1 col-sm-6"
          >
            {{ organization.name }}
          </input-field>
          <input-field
            label="Organization Status"
            label-position="top"
            class="px-1 col-sm-6"
          >
            {{ organizationStatus }}
          </input-field>
        </div>
      </paper-simple>
    <!-- <paper-simple>
      <h4 class="text-main">
        Billing
      </h4>
      <transition
        name="fade"
        mode="out-in"
      >
        <loading-page v-if="loadingPayments" />
        <div v-else>
          <table-busy
            v-if="fetchingPayments"
            class="table-busy"
          />
          <transition-group
            name="fade"
            mode="out-in"
          >
            <template v-for="payment in payments">
              <paper-simple
                :key="payment.id"
                class="border bill mb-0"
              >
                <div class="d-flex align-items-start">
                  <img :src="require('@/assets/svg/image.svg')">
                  <div class="ml-1 w-100">
                    <div class="d-sm-flex justify-content-between">
                      <h5 class="text-main">
                        Billing monthly
                      </h5>
                      <div>
                        <span
                          class="text-capitalize tag"
                          :class="payment.status"
                        >{{ payment.status || '-' }}</span>
                      </div>
                    </div>
                    <div class="text-secondary mt-1 mt-sm-0">
                      <span class="text-main text-medium">Amount Spent</span> - {{ getCurrency(payment.currency) }}{{ payment.amount / 100 }}
                    </div>
                    <div class="text-secondary">
                      <span class="text-main text-medium"> Billing ID:</span> {{ payment.id || '-' }}
                      <a
                        class="icon-right"
                        @click="onCopy(payment.id)"
                      >
                        <GjIcon name="Copy" />
                      </a>
                    </div>
                    <div class="text-secondary">
                      <span class="text-main text-medium"> Description:</span> {{ payment.description || '-' }}
                    </div>
                    <div class="text-secondary">
                      <span class="text-main text-medium">Date:</span> {{ formatOffsetDateTime(payment.date) }}
                    </div>
                  </div>
                </div>
              </paper-simple>
            </template>
          </transition-group>
          <div
            v-if="payments.length === 0"
            class="d-flex justify-content-center align-items-center"
            style="height: 220px"
          >
            No records.
          </div>
          <small-pagination
            v-if="resultInfo.hasMore || payments.length > limit"
            class="mt-1"
            :show-less="payments.length > limit"
            :show-more="resultInfo.hasMore"
            @less="showPayments(true)"
            @more="showPayments(false)"
          />
        </div>
      </transition>
    </paper-simple> -->
    </div>
  </parent>
</template>
<script>
// import redirectError from '@/services/redirectError'
import currencies from './currencies'
// import SmallPagination from './parts/SmallPagination.vue'
import { useClipboard } from '@vueuse/core'

export default {
  name: 'PaymentOverview',
  // components: { SmallPagination },
  data() {
    return {
      currencies,
      limit: 10,
      loadingPayments: true,
    }
  },
  computed: {
    organization() {
      return this.$store.state.organization.organization
    },
    organizationStatus() {
      return this.organization.organizationStatusOptions.find(o => o.id === this.organization.status).value
    },
    fetchingPayments() {
      return this.$store.state.payments.fetchingPayments
    },
    payments() {
      return this.$store.state.payments.payments
    },
    resultInfo() {
      return this.$store.state.payments.paymentsResultInfo
    },
  },
  created() {
    this.$store.dispatch('payments/fetchPayments', { limit: this.limit }).finally(() => { this.loadingPayments = false })
    // .catch(err => redirectError(err, this.$router, this.$route.path))
  },
  methods: {
    showPayments(less) {
      if (less) {
        this.$store.commit('payments/RESET_PAYMENTS', this.limit)
        return
      }
      const query = { limit: this.limit, startingAfter: this.payments[this.payments.length - 1].id }
      this.$store.dispatch('payments/fetchPayments', query)
    },

    onCopy(id) {
      const { copy } = useClipboard()
      copy(id)
      this.copySuccess()
    },

    getCurrency(curr) {
      const el = this.currencies.find(element => element.code === curr)
      return el ? el.symbol : curr
    },
  },
}
</script>
<style lang="scss" scoped>
.bill {
  word-break: break-word;
}

.tag {
  box-sizing: border-box;
  border-radius: 20px;
  padding: 2px 8px;
  color: var(--white);
  font-weight: bold;
  &.succeeded {
    background: var(--success);
    border: 1px solid var(--success);
  }
  &.processing {
    background: var(--primary);
    border: 1px solid var(--primary);
  }
  &.requires_action, &.requires_confirmation {
    background: var(--warning);
    border: 1px solid var(--warning);
  }
  &.requires_payment_method {
    background: var(--danger);
    border: 1px solid var(--danger);
  }
}

.table-busy {
  left: 0;
  z-index: 1;
}
</style>
